// src/constants/network.ts

// PubSub topics
export const PUBSUB_TOPICS = {
  PEER_DISCOVERY: '/p2p/peer-discovery/1.0.0',
  FILE_TRANSFER: 'file-transfer-libp2p',
  // Legacy names kept for compatibility
  FILE_LIST: '/p2p/file-list/1.0.0',
  HAP_FILE_ANNOUNCE: '/p2p/hap-file-announce/1.0.0',
  // Semantic names (same topics, clearer intent)
  FILE_UPLOADED: '/p2p/hap-file-announce/1.0.0',  // Browser -> HAP
  FILES_UPDATED: '/p2p/file-list/1.0.0',          // HAP -> Browsers
  TOPIC_LIST: '/p2p/topic-list/1.0.0',
  SIX_ID_ANNOUNCE: '/p2p/six-id-announce/1.0.0',
  MESH_HEARTBEAT: '/p2p/mesh-heartbeat/1.0.0',
  SIX: (sixId: string) => `/p2p/six/${sixId}/1.0.0`,
  };

  // Timing constants
  export const SYNC_INTERVAL = 60000; // 1 minute
  export const BROADCAST_INTERVAL = 300000; // 5 minutes

  // Topic aliases for clarity
  export const FILE_TRANSFER_TOPIC = PUBSUB_TOPICS.FILE_TRANSFER;
  export const FILE_LIST_TOPIC = (sixId: string) => `${PUBSUB_TOPICS.FILE_LIST}/${sixId}`;
  export const PEER_DISCOVERY_TOPIC = (sixId: string) => `${PUBSUB_TOPICS.PEER_DISCOVERY}/${sixId}`;
  export const TOPIC_LIST_TOPIC = PUBSUB_TOPICS.TOPIC_LIST;
  export const SIX_ID_ANNOUNCE_TOPIC = PUBSUB_TOPICS.SIX_ID_ANNOUNCE;
  export const HAP_FILE_ANNOUNCE_TOPIC = (sixId: string) => `${PUBSUB_TOPICS.HAP_FILE_ANNOUNCE}/${sixId}`;
  export const MESH_HEARTBEAT_TOPIC = PUBSUB_TOPICS.MESH_HEARTBEAT;
  // Semantic topic functions (same as above, clearer names)
  export const FILE_UPLOADED_TOPIC = (sixId: string) => `${PUBSUB_TOPICS.FILE_UPLOADED}/${sixId}`;
  export const FILES_UPDATED_TOPIC = (sixId: string) => `${PUBSUB_TOPICS.FILES_UPDATED}/${sixId}`;
  export const SIX_TOPIC = (sixId: string) => PUBSUB_TOPICS.SIX(sixId);

  // Custom protocols for direct peer-to-peer communication
  export const PROTOCOLS = {
    FILE_ANNOUNCE: '/six3ro/file-announce/1.0.0'
  };
